import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import jwt_decode from 'jwt-decode';

import { environment } from './../../../src/environments/environment';
import { User,UserData } from './../_models';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class AccountService {
    private userSubject: BehaviorSubject<User>;
    public user: Observable<User>;
    public userDecrypt: UserData

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
        this.user = this.userSubject.asObservable();
    }

    public get userValue(): User {
        if(this.userSubject.value== null || this.userSubject.value.expiration== null || !moment().isBefore(this.userSubject.value.expiration)) {
          this.router.navigate(['/publico/login']);
          return null;
        }
        else {
          return this.userSubject.value;
        }
    }



    public get userInfo(): UserData {
      try {
        let datos=jwt_decode(this.userSubject.value.token)as UserData;;        
        return datos as UserData;
      } catch (Error) {
        return null;
      }

  }

    login(username, password) {
        return this.http.post<User>(`${environment.apiUrl}/api/Login/LoginPortal`, { username, password })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
                this.userSubject.next(user);
                return user;
            }));
    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('user');
        localStorage.removeItem('menuItems')
        this.userSubject.next(null);
        this.router.navigate(['/publico/login']);
    }

    ResetPassword(email)
    {
      return this.http.post(`${environment.apiUrl}/api/Login/RecuperarPassword/`+email, null);
    }

    SetPassword(usuario, token, contrasena){
      return this.http.patch(`${environment.apiUrl}/api/Login/RestablecerContrasena`, { usuario, token, contrasena });
    }


    getAll() {
        return this.http.get<User[]>(`${environment.apiUrl}/users`);
    }

    getById(id: string) {
        return this.http.get<User>(`${environment.apiUrl}/users/${id}`);
    }




}
